export enum BrandingType {
  BRANDING_DEFAULT = 'BRANDING_DEFAULT',
  // BRANDING_CUSTOM = 'BRANDING_CUSTOM',
  BRANDING_DISABLED = 'BRANDING_DISABLED',
}

export interface BrandingSettings {
  logo: string | null;
}
